import React from 'react';
import { BrandEmblem } from './BrandEmblem';
interface LogoProps {
  tone?: 'dark' | 'light';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
const sizes = {
  sm: {
    emblem: 'h-9',
    word: 'text-[1.35rem]',
    sub: 'text-[7px]'
  },
  md: {
    emblem: 'h-11',
    word: 'text-[1.6rem]',
    sub: 'text-[8px]'
  },
  lg: {
    emblem: 'h-16',
    word: 'text-[2.3rem]',
    sub: 'text-[10px]'
  }
};

/** Horizontal lockup of the Bel Air logo: emblem + “Bel Air / Luxury Apartment” wordmark. */
export function Logo({
  tone = 'dark',
  size = 'md',
  className = ''
}: LogoProps) {
  const s = sizes[size];
  const onDark = tone === 'light';
  return <span className={`inline-flex items-center gap-3 ${className}`} data-id="element-268" data-mp="dr4pka2xlq3w">
      <BrandEmblem className={`${s.emblem} w-auto shrink-0`} primary={onDark ? '#F7F4ED' : '#0B332B'} accent="#C6A15B" title="" data-id="element-269" data-mp="hthuwxdrnm05" />
      <span className="flex flex-col leading-none" data-id="element-270" data-mp="2ykhybnczs0bu">
        <span className={`font-display font-semibold ${s.word} tracking-[0.02em] ${onDark ? 'text-ivory-100' : 'text-forest-700'}`} data-id="element-271" data-mp="32k8rtytwkuk2">
          Bel Air
        </span>
        <span className={`mt-1 flex items-center gap-1.5 font-sans font-medium uppercase ${s.sub} tracking-wordmark ${onDark ? 'text-gold-300' : 'text-gold-600'}`} data-id="element-272" data-mp="19wgb7geg7wxy">
          Luxury Apartment
        </span>
      </span>
    </span>;
}